import React from "react";
import { createApi } from "../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { NavigateFunction } from "react-router-dom";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";

export const handleAddCalendarDates = (
  newDate: any,
  setCalendarEvents: any,
  setEditingCalendar: Dispatcher<boolean>,
  navigate: NavigateFunction
) => {
  const AxiosUI = createApi(``);

  const retryFunction = () => {
    handleAddCalendarDates(
      newDate,
      setCalendarEvents,
      setEditingCalendar,
      navigate
    );
  };

  AxiosUI.post(`calendar_event/`, {
    ...newDate,
    start_time: newDate.start_time ?? "00:00:00",
    end_time: newDate.end_time ?? "23:59:59",
  }).then(
    (response: AxiosResponse) => {
      AxiosUI.get(
        `calendar_event/?calendar__id=${response.data.calendar}`
      ).then(
        (response: AxiosResponse) => {
          setCalendarEvents(response.data.results);
          setEditingCalendar(false);
        },
        (reason: AxiosError) => {
          universalAPIErrorHandler(reason, navigate, retryFunction, () => {
            setEditingCalendar(false);
          });
        }
      );
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        alert("Error adding date, please try again");
        setEditingCalendar(false);
      });
    }
  );
};
